import PlanAdd from "@/views/plan/PlanAdd";
import PlanList from "@/views/plan/PlanList";
import PlanEdit from "@/views/plan/PlanEdit";


const routes = [
 {
    path: '/Plan/Add',
    name: 'PlanAdd',
    component: PlanAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/Plan/List',
    name: 'PlanList',
    component: PlanList,
    meta:{requiredAuth:true}
  },
 {
    path: '/Plan/Edit/:id',
    name: 'PlanEdit',
    component: PlanEdit,
    meta:{requiredAuth:true}
  },
]

export default routes